// extracted by mini-css-extract-plugin
export default {"primeCheckBoxLabel":"PrimeCheckBox_primeCheckBoxLabel__jYfMA","primeCheckBoxSVG":"PrimeCheckBox_primeCheckBoxSVG__jSw+b","primeChechbox":"PrimeCheckBox_primeChechbox__kLsub"};